import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {
  errCode: string;
  // fieldErrors;
  title: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.title = this.data.error.title;
    this.message = 'Something went wrong. Please contact our help desk.';
    if (!!this.data.error.error) {
      if (+this.data.error.error.errcode === 50000) {
        this.message = 'Your session has expired. Please login again.';
      } else if (+this.data.error.error.errcode === 403) {
        this.message = 'Your session has expired. Please login again.';
        // this.message = this.data.error.error.errtext;
      } else if (!!this.data.error.error.message) {
        this.message = this.data.error.error.message;
      }
    }
    /*if (this.data.error.error) {
      if (this.data.error.error.fieldErrors) {
        this.fieldErrors = this.data.error.error.fieldErrors;
        console.log('fieldErrors');
      }
    }*/
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
